import React, { useEffect } from "react";
import DateSelect from "./dateSelect/DateSelect";
import styled from "styled-components";
import WorkHours from "./workHours/WorkHours";

import { Title } from "../common/Title";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import CommonContainer from "../common/CommonContainer";

const Schedule = () => {
  const { workType, visitTime, hour } = useSelector((state) => ({
    workType: state.form.workType,
    visitTime: state.form.schedule.visitTime,
    hour: state.form.schedule.hour,
  }));
  const navigate = useNavigate();

  // 새로고침 시 첫페이지로 이동
  useEffect(() => {
    if (!workType) {
      navigate("/");
    }
  }, [navigate, workType]);

  return (
    <CommonContainer
      button={true}
      disabled={visitTime && hour !== 0 ? false : true}
      handleNextClick={() => navigate("/address")}
    >
      <Container>
        <SizeBox styleHeight={"2rem"} />
        <Title
          title="돌봄 스케줄"
          description="돌봄 스케줄을 설정해주세요"
          progressNum={2}
        />
        <SizeBox styleHeight={"2rem"} />
        <DateSelect />
        <WorkHours />
      </Container>
    </CommonContainer>
  );
};

const SizeBox = styled.div`
  width: 100%;
  height: ${(props) => props.styleHeight};
`;

const Container = styled.div`
  width: 100%;
  height: 39.875rem;
  box-sizing: border-box;
  padding: 0 16px;
  font-family: "SpoqaHanSansNeoRegular";
  font-size: 14px;
  font-weight: 700;

  .active {
    background-color: ${(props) => props.selectColor};
    color: #ffffff;
  }
`;




export default Schedule;
